import { topicsData } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 border-accent-200 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">热门话题标签</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时追踪全网最火黑料话题，点击标签查看相关爆料合集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href={`#topics`}
              className={`flex items-center gap-4 p-4 rounded-xl border transition-all duration-200 cursor-pointer ${colorMap[topic.color] || colorMap.secondary}`}
            >
              <div className="w-12 h-12 rounded-xl bg-background-50 flex items-center justify-center flex-shrink-0">
                <i className={`${topic.icon} text-xl ${topic.color === 'primary' ? 'text-primary-600' : topic.color === 'accent' ? 'text-accent-600' : 'text-secondary-600'}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-sm truncate">{topic.name}</span>
                  {topic.tag && (
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold flex-shrink-0 whitespace-nowrap ${topic.tag === '爆' ? 'bg-primary-500 text-background-50' : topic.tag === '热' ? 'bg-accent-500 text-background-50' : 'bg-primary-400 text-background-50'}`}>
                      {topic.tag}
                    </span>
                  )}
                </div>
                <span className="text-xs opacity-70">热度 {topic.heat}</span>
              </div>
              <i className="ri-arrow-right-s-line text-lg flex-shrink-0 opacity-50"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}